// Currently, just contains the Skyscapes x Playground series
// TODO: clean this up later
const DENYLIST_FOR_SERIES = ["2WTAsMewCkHvABYtUgsYcz7gh8hbWNigWowyLfox46Yk"];

export default DENYLIST_FOR_SERIES;
